import type { ShopItem } from '../types'
import { describeShopItem } from '../utils/shopFormatters'

// Exact source artwork exported from Figma QLmJxm4NYgXm7ioLbPRjza, page 81:188.
const root = '/assets/webshop/'
export const shopArtwork = {
    logo: root + '81-439-imgCasinoLogo.png',
    merkurLogo: root + 'merkur-logo.png',
    header: root + '81-439-img1Kopfzeile.png',
    avatar: root + '81-439-imgSnowmansHead.png',
    coin: root + '109-10894-imgCoin3.png',
    deals: root + '109-10891-imgIcoSale1.png',
    joker: root + '109-11123-imgJoker2.png',
    chipsSmall: root + '82-1721-imgChatGptImage12Aug20261129251.png',
    chipsMedium: root + '82-1716-imgChatGptImage12Aug20261045281.png',
    chipsLarge: root + '82-1740-imgChatGptImage12Aug20261049081.png',
    chipsChest: root + 'chips-chest.png',
    chipsSafe: root + 'chips-safe.png',
    chipsStackLarge: root + 'chips-stack-large.png',
    chipsBag: root + 'chips-3.png',
    gift: root + '81-778-imgIconGiftbox.png',
    ultimateDecoPink: root + 'ultimate-deco-pink.png',
    ultimateDecoOrange: root + 'ultimate-deco-orange.png',
    ultimateRibbon: root + 'ultimate-pass-ribbon.png',
    ultimate: root + '81-778-imgPlusIconKopie1.png',
    stampHighlight: root + '81-778-imgEllipse48.svg',
    bonusOpen: root + 'chevron-down-4x.png',
    bonusArrow: root + 'bonus-arrow.svg',
    bonusClosed: root + 'chevron-up-4x.png',
    chevron: root + 'figmaCard-imgAufklappenZu.svg',
    league: root + 'figmaCard-imgLeaguePoints.png',
    loyalty: root + 'figmaCard-imgLoyaltyPoints.png',
    trophy: root + 'figmaCard-imgTrophy1.png',
}

export function productArtwork(item: ShopItem, hot = false) {
    if (item.type === 'ultimate-pass') return shopArtwork.ultimate
    if (describeShopItem(item).joker) return shopArtwork.joker
    const icons: Record<string, string> = { 'chips-1': shopArtwork.chipsSmall, 'chips-2': shopArtwork.chipsMedium, 'chips-3': shopArtwork.chipsBag, 'chips-4': shopArtwork.chipsLarge, 'chips-5': shopArtwork.chipsChest, 'chips-6': shopArtwork.chipsSafe, 'chips-7': shopArtwork.chipsStackLarge }
    if (item.iconSlug && icons[item.iconSlug]) return root + `chips-design-${item.iconSlug.slice(-1)}.png`
    if (hot) return item.amount >= 1e9 ? shopArtwork.chipsBag : shopArtwork.gift
    if (item.amount >= 100e9) return root + 'chips-design-4.png'
    if (item.amount >= 38e9) return root + 'chips-design-3.png'
    if (item.amount >= 13e9) return root + 'chips-design-2.png'
    return root + 'chips-design-1.png'
}

// Presentation only: five fixed Figma designs, in catalog order. Offer data stays untouched.
export const hotDealDesigns = [
    { name: 'big-catch', artwork: root + 'hot-big-catch.png' },
    { name: 'special-gift', artwork: shopArtwork.gift },
    { name: 'golden-hour', artwork: root + 'chips-design-3.png' },
    { name: 'lucky-streak', artwork: root + 'hot-lucky-streak.png' },
    { name: 'high-roller', artwork: root + 'hot-high-roller.png' },
] as const
